import { ArrowRightLeft, ChevronDown, ImageOff, Trash2 } from "lucide-react";
import { useMemo, useState } from "react";

import { miniaturaDe } from "@/utils/miniatura";

import { cancelados, reais, vivos } from "./lib";

/** Foto do item: a gravada no pedido; sem ela, a do cadastro do produto. */
function fotoDoItem(it, fotos) {
  return it.photo_url || fotos.get(String(it.product_id || it.id || "")) || null;
}

function Linha({ it, idx, foto, podeAgir, onCancelar, onTransferir }) {
  const qtd = Number(it.quantidade || 1);
  const linha = Number(it.preco || 0) * qtd;
  return (
    <div className={`flex gap-3 py-2.5 ${it.deleted ? "opacity-50" : ""}`} data-e2e="comanda-item">
      <div className="w-12 h-12 rounded-lg overflow-hidden bg-muted grid place-items-center shrink-0" data-e2e="comanda-item-foto">
        {foto ? <img src={miniaturaDe(foto, 128)} alt="" loading="lazy" className="w-full h-full object-cover" />
          : <ImageOff className="w-5 h-5 text-muted-foreground/40" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-semibold leading-tight ${it.deleted ? "line-through" : ""}`}>
          <span className="text-orange-500 mr-1">{qtd % 1 ? qtd.toFixed(3).replace(".", ",") : qtd}×</span>{it.nome}
        </p>
        {(it.subitems || []).length > 0 && (
          <p className="text-xs text-muted-foreground truncate">{it.subitems.map((s) => `${s.quantidade > 1 ? `${s.quantidade}x ` : ""}${s.nome}`).join(", ")}</p>
        )}
        {it.observacao && <p className="text-xs text-amber-600 dark:text-amber-400">Obs: {it.observacao}</p>}
        {it.deleted && <p className="text-[11px] text-muted-foreground">{it.transferido_para ? "Transferido" : "Cancelado"}{it.motivo_cancelamento ? ` · ${it.motivo_cancelamento}` : ""}</p>}
      </div>
      <div className="text-right shrink-0">
        <p className={`text-sm font-bold tabular-nums ${it.deleted ? "line-through text-muted-foreground" : ""}`}>{reais(linha)}</p>
        {!it.deleted && podeAgir && (
          <div className="flex gap-1 justify-end mt-1">
            <button type="button" onClick={() => onTransferir(idx, it)} title="Transferir para outra comanda" aria-label="Transferir"
              className="h-7 w-7 grid place-items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"><ArrowRightLeft className="w-3.5 h-3.5" /></button>
            <button type="button" onClick={() => onCancelar(idx, it)} title="Cancelar item" aria-label="Cancelar item"
              className="h-7 w-7 grid place-items-center rounded-md text-muted-foreground hover:bg-destructive/10 hover:text-destructive"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        )}
      </div>
    </div>
  );
}

/** Os itens já lançados na comanda (vivos primeiro; cancelados e transferidos recolhidos). */
export default function ItensLancados({ items, allProducts = [], podeAgir = true, onCancelar, onTransferir }) {
  const [verCancelados, setVerCancelados] = useState(false);
  const fotos = useMemo(() => new Map((allProducts || []).filter((p) => p?.photo_url).map((p) => [String(p.id), p.photo_url])), [allProducts]);
  const v = vivos(items);
  const c = cancelados(items);
  if (!v.length && !c.length) {
    return <p className="text-sm text-muted-foreground py-4 text-center">Nada lançado ainda. Escolha os produtos ao lado e toque em <b>Enviar</b>.</p>;
  }
  return (
    <div>
      <div className="divide-y">
        {v.map(({ it, idx }) => <Linha key={idx} it={it} idx={idx} foto={fotoDoItem(it, fotos)} podeAgir={podeAgir} onCancelar={onCancelar} onTransferir={onTransferir} />)}
      </div>
      {c.length > 0 && (
        <div className="mt-2 pt-2 border-t">
          <button type="button" onClick={() => setVerCancelados((x) => !x)} className="text-xs text-muted-foreground inline-flex items-center gap-1 hover:text-foreground">
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${verCancelados ? "rotate-180" : ""}`} /> {c.length} {c.length === 1 ? "item cancelado ou transferido" : "itens cancelados ou transferidos"}
          </button>
          {verCancelados && <div className="divide-y">{c.map(({ it, idx }) => <Linha key={idx} it={it} idx={idx} foto={fotoDoItem(it, fotos)} podeAgir={false} />)}</div>}
        </div>
      )}
    </div>
  );
}
